export default __webpack_public_path__ + "static/media/6.5abb949a.png";